module.exports = "<app-subheader></app-subheader>\n<app-our-services></app-our-services>\n<app-statistics></app-statistics>\n<app-team></app-team>\n<app-quotes></app-quotes>\n<app-footer></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/about us/about-us.component.html
// module id = ../../../../../src/app/about us/about-us.component.html
// module chunks = 0